/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "shared": {
                        "nested": {
                          "Device": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "name": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "deviceCodeId": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "locationId": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "createdAt": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "updatedAt": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.shared?.nested?.Device) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Device @ squareup/devicesettings/profiles/v2/model/shared/device.proto at 10:1
 */
export const Device = $root.lookupType('squareup.devicesettings.profiles.v2.model.shared.Device');
fixType(Device);
Builder.createAndAttachToType(Device);